import { Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";

const useStyle = makeStyles((theme) => ({
  hrmsProjectSearchContainer: {
    cursor: "pointer",
    margin: "5px 0px",
    display: "flex",
    justifyContent: "space-between",
  },
  hrmsProjectSearch: {
    display: "flex",
    marginLeft: "5px",
  },
}));
const ProjectSearch = ({ highlightText, item }) => {
  const navigate = useNavigate();

  const classes = useStyle();

  const handleRedirect = ({ props }) => {
    navigate("/project");
  };

  return (
    <>
      <Grid
        onClick={handleRedirect}
        className={classes.hrmsProjectSearchContainer}
      >
        <Grid className={classes.hrmsProjectSearch}>
          <Typography>{highlightText(item.title)}</Typography>
        </Grid>
        <Typography>{highlightText(item.created_by)}</Typography>
      </Grid>
    </>
  );
};

export default ProjectSearch;
